export default "__VITE_ASSET__fUNx6LFb__"